module.exports = __webpack_public_path__ + "static/media/screenshot_history_4_ru.2156e641.png";